import PropTypes from 'prop-types';
import PropertyRecord from 'customer-data-objects/property/PropertyRecord';
import PropertyDefinitionPropType from './PropertyDefinitionPropType';
export default PropTypes.oneOfType([PropTypes.instanceOf(PropertyRecord), PropertyDefinitionPropType]);